export const Weekly = 'Week';
export const Monthly = 'Month';
export const Quarterly = 'Quarter';
export const Annual = 'Annual';
